import { Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { T4 } from '@app/models/payroll/t4.model';
import { T4NotificationsService } from '@app/modules/payroll/services';
import { ReturnUpdateView } from '../../return-update.view';

@Component({
    templateUrl: './t4-update.template.html',
    styleUrl: '../../return-update.style.scss',
})
export class T4UpdateView extends ReturnUpdateView {
    get t4(): T4 {
        return this.taxForm as T4;
    }

    employeeNotifications = toSignal(this.t4NotificationService.getEmployeeNotifications(this.t4));

    constructor(
        route: ActivatedRoute,
        private t4NotificationService: T4NotificationsService
    ) {
        super(route, 't4');
    }

    async save(): Promise<void> {
        if (!this.isFormValid) {
            return;
        }
        this.isLoading = true;
        try {
            await this.t4.save();
            this.notify.success('payroll.taxForms.T4.employee.edit.success');

            this.router.navigate(['..'], { relativeTo: this.route });
        } catch (e) {
            this.notify.error(e);
            this.isLoading = false;
        }
    }
}
